import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { MainTitle } from '../../../common/index.jsx';
import { useTranslation } from 'react-i18next';
import FormTextField from '../../../antd/form/FormTextField/FormTextField.jsx';
import FormTextArea from '../../../antd/form/FormTextArea/FormTextArea.jsx';
import { email, required } from '../../../antd/form/FormValidation.js';
import FormButton from '../../../antd/form/FormButton/FormButton.jsx';
import FormButtonsContainer from '../../../antd/form/FormButtonsContainer/FormButtonsContainer.jsx';
import Form from '../../../antd/form/Form/Form.jsx';
import FormHiddenField from '../../../antd/form/FormHiddenField/FormHiddenField.jsx';

const CongratulationsForm = ({
  form,
  categoryOptions: _categoryOptions,
  initialValues,
  onFinish,
}) => {
  // Use global i18n and set language on mount if on /congratulations
  const { t, i18n } = useTranslation();
  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      window.location.pathname === '/congratulations' &&
      i18n.language !== 'en'
    ) {
      i18n.changeLanguage('en');
    }
  }, []);

  // State just to mark reCAPTCHA readiness
  const [, setGrecaptchaReady] = useState(false);

  // Načítanie reCAPTCHA skriptu
  useEffect(() => {
    let script;

    if (!window.grecaptcha) {
      script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${import.meta.env.VITE_RECAPTCHA_SITE_KEY}`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        window.grecaptcha.ready(() => setGrecaptchaReady(true));
        // Zobraz badge ak existuje
        const badge = document.querySelector('.grecaptcha-badge');
        if (badge) badge.style.display = '';
      };
      document.body.appendChild(script);
    } else {
      window.grecaptcha.ready(() => setGrecaptchaReady(true));
      // Zobraz badge ak existuje
      const badge = document.querySelector('.grecaptcha-badge');
      if (badge) badge.style.display = '';
    }

    return () => {
      const badge = document.querySelector('.grecaptcha-badge');
      if (badge) badge.style.display = 'none';
      if (script) document.body.removeChild(script);
    };
  }, []);

  // Skry ikony pri zobrazení CongratulationsForm
  useEffect(() => {
    const elements = document.getElementsByClassName(
      'application-questions-container',
    );
    const prevDisplays = [];
    for (let i = 0; i < elements.length; i++) {
      prevDisplays[i] = elements[i].style.display;
      elements[i].style.display = 'none';
    }
    return () => {
      for (let i = 0; i < elements.length; i++) {
        elements[i].style.display = prevDisplays[i] || '';
      }
    };
  }, []);

  const handleFinish = (values) => {
    if (!window.grecaptcha) {
      onFinish({ ...values, captchaResponse: '' });
      return;
    }

    window.grecaptcha.ready(() => {
      // reCAPTCHA execute vracia Promise s tokenom
      window.grecaptcha
        .execute(import.meta.env.VITE_RECAPTCHA_SITE_KEY, {
          action: 'congratulations',
        })
        .then((token) => {
          if (!token) {
            console.error('reCAPTCHA token is null');
          }
          onFinish({ ...values, captchaResponse: token });
        });
    });
  };

  return (
    <Form form={form} onFinish={handleFinish} initialValues={initialValues}>
      <MainTitle title={t('Blahoželanie pre FRI UNIZA')} />

      <FormTextField
        label={t('Meno a priezvisko')}
        name={'name'}
        extra={t('Od koho je blahoželanie?')}
        rules={[required(t)]}
      />

      <FormTextField
        label={t('E-mailová adresa')}
        name={'email'}
        extra={t(
          'Na tento e-mail Vám pošleme text blahoželania na schválenie pre účely propagovania na sociálnych sieťach.',
        )}
        rules={[required(t), email(t)]}
      />

      <FormTextField
        label={t('Aktuálna pozícia alebo študijný status')}
        name={'subject'}
        extra={t(
          'napr. Project Manager v XY / študent XY. ročníka študijného programu XY/ Absolvent ŠP XY rok XY',
        )}
        rules={[required(t)]}
      />

      <FormTextArea
        label={t('Text blahoželania')}
        name={'text'}
        rules={[required(t)]}
        rows={'6'}
      />

      <span
        style={{
          display: 'block',
          marginBottom: '8px',
          marginTop: '-24px',
          color: 'rgba(0,0,0,0.45)',
        }}
      >
        {t(
          'napr. Všetko najlepšie! FRI mi otvorila dvere do sveta IT a som za to vďačný.',
        )}
      </span>

      <FormButtonsContainer>
        <FormButton submitOnClick={true} submitKey={'contact'}>
          {t('Odoslať blahoželanie')}
        </FormButton>
      </FormButtonsContainer>
    </Form>
  );
};

CongratulationsForm.propTypes = {
  categoryOptions: PropTypes.any,
};

export default CongratulationsForm;
